var __templateData = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (Math, i18n, stars, undefined) {
var parentKlass, max = 9;
if (stars.length < 2)      parentKlass = "text-xl";
else if (stars.length < 6) parentKlass = "text-lg";
else if (stars.length < 8) parentKlass = "text-md";
else { parentKlass = "text-sm"; };
buf.push("<div" + (jade.cls(['text-nowrap',parentKlass], [null,true])) + ">");
// iterate stars.slice(0, max)
;(function(){
  var $$obj = stars.slice(0, max);
  if ('number' == typeof $$obj.length) {

    for (var i = 0, $$l = $$obj.length; i < $$l; i++) {
      var star = $$obj[i];

if (!star) star = {};
var klass = "delay-" + Math.min(i, 10);
if (star.complete) klass += " active";
if (stars.length > 6) klass += " bunched";
buf.push("<div" + (jade.cls(['star',klass], [null,true])) + "></div>");
    }

  } else {
    var $$l = 0;
    for (var i in $$obj) {
      $$l++;      var star = $$obj[i];

if (!star) star = {};
var klass = "delay-" + Math.min(i, 10);
if (star.complete) klass += " active";
if (stars.length > 6) klass += " bunched";
buf.push("<div" + (jade.cls(['star',klass], [null,true])) + "></div>");
    }

  }
}).call(this);

buf.push("</div><h4 class=\"text-bold text-nowrap\"> ");
var earned = _.where(stars, { complete: true }).length
buf.push("" + (jade.escape((jade_interp = i18n("stars.earned", { earned: earned, smart_count: stars.length })) == null ? '' : jade_interp)) + "</h4>");}.call(this,"Math" in locals_for_with?locals_for_with.Math:typeof Math!=="undefined"?Math:undefined,"i18n" in locals_for_with?locals_for_with.i18n:typeof i18n!=="undefined"?i18n:undefined,"stars" in locals_for_with?locals_for_with.stars:typeof stars!=="undefined"?stars:undefined,"undefined" in locals_for_with?locals_for_with.undefined:typeof undefined!=="undefined"?undefined:undefined));;return buf.join("");
};
if (typeof define === 'function' && define.amd) {
  define([], function() {
    return __templateData;
  });
} else if (typeof module === 'object' && module && module.exports) {
  module.exports = __templateData;
} else {
  __templateData;
}